import makeHttpRequest from '../helpers/ajax';
import wwwUrlEnv from '../helpers/www-url-env';

const getMortgageTrendUrl = () => `${wwwUrlEnv.getWWWURL()}/wp-json/interestrate/v1`;

const getDailyMortgageRates = (product, crditRange, loanProgramType) => {
    const errorResponse = {};
    const loanProgram = loanProgramType !== '' ? loanProgramType : 'conventional';
    if (!product || !crditRange) {
        return errorResponse;
    }

    let url = getMortgageTrendUrl();
    url += `?product=${product}&creditRange=${crditRange}`;
    url += `&loanProgramType=${loanProgram}`;
    const request = {
        url,
        storage_key: `${product}_${crditRange}_${loanProgram}_trend`,
    };
    return makeHttpRequest(request).then((response) => {
        const trendResult = JSON.parse(response);
        if (trendResult.result && Number(trendResult.statusCode) === 200) return trendResult.result;
        return {};
    }, (error) => {
        console.warn(`There is some issue with network call for lender reviews, please try again ${error}`);
        return errorResponse;
    });
};

export default {
    getDailyMortgageRates,
};
